import {Component, Input, OnInit} from "@angular/core";
import {FormArray, FormGroup} from "@angular/forms";

@Component({
  selector: 'app-date-range-select',
  templateUrl: './date-range-select.component.html',
  styleUrls: ['./date-range-select.component.scss']
})

export class DateRangeSelectComponent implements OnInit{
  @Input() formGroupParent: FormGroup;
  @Input() formName: string;
  @Input() formValue: any;
  @Input() index: any;
  @Input() fieldVal: any;
  @Input() labelName: string;
  @Input() selectedVal: string;
  @Input() mandatory: boolean;
  @Input() disabledBol: boolean;
  @Input() classCustom: string;
  @Input() classIcon: string;
  @Input() classCol: string;
  @Input() show: boolean;
  dateBefore: any;
  dateAfter: any;
  arr = ['', ''];

  constructor() {

  }

  ngOnInit() {
    if (this.formValue) {
      const myArray = this.formValue.split(" / ");
      if (myArray) {
        for (let i = 0; i < myArray.length; i++) {
          if (i == 0) {
            this.dateBefore = myArray[0];
          } else if (i == 1) {
            this.dateAfter = myArray[1];
          }
        }
      }
    }
  }

  beforeChange(evt) {
    this.dateBefore = evt;
    this.arr[0] = this.dateBefore
    const arrayForm = this.formGroupParent.get(this.formName) as FormArray;
    const formGroupArray = arrayForm.controls[this.index] as FormGroup;
    formGroupArray.controls[this.fieldVal].setValue(this.formatter());

  }

  afterChange(evt) {
    this.dateAfter = evt;
    this.arr[1] = this.dateAfter
    const arrayForm = this.formGroupParent.get(this.formName) as FormArray;
    const formGroupArray = arrayForm.controls[this.index] as FormGroup;
    formGroupArray.controls[this.fieldVal].setValue(this.formatter());
  }

  formatter() {
    return this.arr[0] + ' / ' + this.arr[1]
  }

  // helpers for View
  isControlValid(controlName: string): boolean {
    const control = this.formGroupParent.controls[controlName];
    return control.valid && (control.dirty || control.touched);
  }

  isControlInvalid(controlName: string): boolean {
    const control = this.formGroupParent.controls[controlName];
    return control.invalid && (control.dirty || control.touched);
  }

  controlHasError(validation, controlName): boolean {
    const control = this.formGroupParent.controls[controlName];
    return control.hasError(validation) && (control.dirty || control.touched);
  }

  isControlTouched(controlName): boolean {
    const control = this.formGroupParent.controls[controlName];
    return control.dirty || control.touched;
  }
}
